import React, {useState} from 'react';
import {CardContent,} from '@mui/material';
import ShiftDetailDialog from '@/components/events/ShiftDetailDialog.tsx';
import ShiftsDataGrid from '@/components/events/ShiftsDataGrid.tsx';
import PageWrapper from '@/components/layout/PageWrapper';
import {useTranslation} from 'react-i18next';
import {ExtendedShiftData} from "@/components/shifts/ShiftItem.tsx";
import MobileFriendlyCard from "@/components/common/MobileFriendlyCard.tsx";

const Dashboard = () => {
  const [selectedShift, setSelectedShift] = useState<ExtendedShiftData | null>(null);
  const [detailDialogOpen, setDetailDialogOpen] = useState(false);
  const { t } = useTranslation();

  const handleInfoClick = (shift: ExtendedShiftData) => {
    setSelectedShift(shift);
    setDetailDialogOpen(true);
  };

  const handleCloseDetailDialog = () => {
    setDetailDialogOpen(false);
  };

  return (
    <PageWrapper title={t('pages.dashboard.title')}>
      <MobileFriendlyCard elevation={0} sx={{ width: '100%' }}>
        <CardContent sx={{display: 'flex', flex: 1, flexDirection: 'column', gap: 1, overflow: 'hidden' }}>
          <ShiftsDataGrid
            onViewDetails={handleInfoClick}
          />
        </CardContent>
      </MobileFriendlyCard>
      <ShiftDetailDialog
        shift={selectedShift}
        open={detailDialogOpen}
        onClose={handleCloseDetailDialog}
      />
    </PageWrapper>
  );
};

export default Dashboard;
